var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48439 27.4423C10.4055 13.7695 23.0469 4.24292 36.7197 6.16405L53.2276 8.48351C66.9004 10.4046 76.427 23.046 74.5059 36.7188L69.4036 73.0321C69.0194 75.7667 66.4911 77.672 63.7565 77.2878L27.4432 72.1855C13.7704 70.2644 4.24381 57.623 6.16493 43.9502L8.48439 27.4423Z",
    fill: "#CDEED4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 24.8663C29.0333 20.6663 33.0999 20.5663 37.3999 24.8663L40.0332 27.4997C40.2666 27.733 40.3332 28.0663 40.2665 28.3663C38.6332 34.0997 34.0665 38.6663 28.3332 40.2997C28.2665 40.333 28.1666 40.333 28.0666 40.333C27.8333 40.333 27.5999 40.233 27.4332 40.0663L24.8333 37.4663C22.6999 35.333 21.6665 33.2997 21.6665 31.233C21.6665 29.0663 22.6999 26.9997 24.8333 24.8663Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1992 42.2327C32.8326 41.9327 33.4326 41.6327 33.9993 41.2661C34.4659 40.9994 34.9325 40.6994 35.3658 40.3661C35.7325 40.1327 36.1659 39.7994 36.5993 39.4327C36.6659 39.3994 36.7992 39.2994 36.9659 39.0994C37.6659 38.4994 38.4659 37.6994 39.1992 36.8661C39.2659 36.8327 39.3659 36.6661 39.4992 36.4661C39.7326 36.1994 40.0659 35.7661 40.3992 35.2994C40.6659 34.9661 40.9659 34.4994 41.2325 34.0327C41.5659 33.4661 41.8992 32.8661 42.1659 32.2661C42.4659 31.5994 42.6992 30.9994 42.9326 30.3994L55.4992 42.9661C56.3325 43.7994 57.0992 45.3327 57.2659 46.4661L58.2326 53.3994C58.4659 54.8661 58.0326 56.2327 57.1326 57.1661C56.3659 57.9327 55.2992 58.3327 54.1325 58.3327C53.8658 58.3327 53.6326 58.2994 53.3659 58.2661L46.4325 57.2994C45.2992 57.1328 43.7659 56.3661 42.9326 55.5327L30.3658 42.9661C30.9658 42.7327 31.5659 42.4994 32.1992 42.2327Z",
    fill: "#292D32"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32270_12771)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#00861E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1667 43.9997V45.9997C45.1667 48.6664 49 49.833 49 49.833C49 49.833 44.5833 53.1664 40 53.1664C35.4167 53.1664 31 49.833 31 49.833C31 49.833 34.8635 48.6664 34.8333 45.9997C34.8032 43.333 34.8233 41.7664 34.8032 37.1977C32.4145 34.1015 32.5678 32.0235 33.874 30.5622C38.25 25.6664 50.1667 27.333 50.1667 27.333C50.1667 27.333 51.2787 39.3319 48.75 42.833C47.6667 44.333 45.1667 43.9997 45.1667 43.9997Z",
    fill: "url(#paint0_linear_32270_12771)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M45.1673 44C41.5007 43.5833 39.334 42 39.334 42C40.7019 44.0237 42.7866 45.4532 45.1673 46V44Z",
    fill: "url(#paint1_linear_32270_12771)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 54.884C59.0867 58.1102 60 65.5507 60 65.5507H20C20 65.5507 20.9137 58.1093 22.5 54.884C24.0863 51.6587 33.35 48.6672 33.35 48.6672C35.1355 52.3327 44.9347 52.3327 46.6452 48.666C46.6452 48.666 55.9133 51.6578 57.5 54.884Z",
    fill: "url(#paint2_linear_32270_12771)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.334 61.3333C39.334 61.2015 39.3731 61.0726 39.4463 60.963C39.5196 60.8533 39.6237 60.7679 39.7455 60.7174C39.8673 60.667 40.0014 60.6538 40.1307 60.6795C40.26 60.7052 40.3788 60.7687 40.4721 60.8619C40.5653 60.9552 40.6288 61.074 40.6545 61.2033C40.6802 61.3326 40.667 61.4666 40.6166 61.5885C40.5661 61.7103 40.4807 61.8144 40.371 61.8876C40.2614 61.9609 40.1325 62 40.0007 62C39.8238 62 39.6543 61.9298 39.5292 61.8047C39.4042 61.6797 39.334 61.5101 39.334 61.3333ZM39.334 58C39.334 57.8681 39.3731 57.7393 39.4463 57.6296C39.5196 57.52 39.6237 57.4345 39.7455 57.3841C39.8673 57.3336 40.0014 57.3204 40.1307 57.3461C40.26 57.3719 40.3788 57.4354 40.4721 57.5286C40.5653 57.6218 40.6288 57.7406 40.6545 57.8699C40.6802 57.9993 40.667 58.1333 40.6166 58.2551C40.5661 58.3769 40.4807 58.4811 40.371 58.5543C40.2614 58.6276 40.1325 58.6667 40.0007 58.6667C39.8238 58.6667 39.6543 58.5964 39.5292 58.4714C39.4042 58.3464 39.334 58.1768 39.334 58ZM39.334 54.6667C39.334 54.5348 39.3731 54.4059 39.4463 54.2963C39.5196 54.1867 39.6237 54.1012 39.7455 54.0507C39.8673 54.0003 40.0014 53.9871 40.1307 54.0128C40.26 54.0385 40.3788 54.102 40.4721 54.1953C40.5653 54.2885 40.6288 54.4073 40.6545 54.5366C40.6802 54.6659 40.667 54.8 40.6166 54.9218C40.5661 55.0436 40.4807 55.1477 40.371 55.221C40.2614 55.2942 40.1325 55.3333 40.0007 55.3333C39.8238 55.3333 39.6543 55.2631 39.5292 55.1381C39.4042 55.013 39.334 54.8435 39.334 54.6667V54.6667Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8593 32.2009C36.3293 31.7458 35.6853 31.4393 34.775 31.9123C32.6168 33.0328 34.2501 37.3328 36.1668 37.3328C36.6668 37.3328 36.9155 38.9031 34.6893 39.9994C34.6893 38.2494 32.0226 33.9161 31.7893 29.9708C29.106 28.9716 29.7726 24.9738 31.6148 24.9738C31.3208 21.3091 37.1893 19.4161 39.4616 21.5193C41.7726 18.7494 47.606 20.1661 47.9581 22.5691C51.9693 20.4279 54.606 26.5828 50.8501 28.9721C49.3046 29.9554 45.6893 30.3296 40.4705 30.3296C39.6826 30.3296 39.2413 30.5253 39.4616 31.4994C39.8881 33.3871 38.898 34.5761 36.8593 32.2009Z",
    fill: "url(#paint3_linear_32270_12771)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32270_12771",
    x1: 40.7051,
    y1: 27.0596,
    x2: 40.7051,
    y2: 53.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32270_12771",
    x1: 44.0648,
    y1: 42.752,
    x2: 43.0431,
    y2: 46.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32270_12771",
    x1: 40,
    y1: 48.666,
    x2: 40,
    y2: 65.5507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32270_12771",
    x1: 41.3307,
    y1: 19.999,
    x2: 41.3307,
    y2: 39.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32270_12771"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/message-edit.bb122d66533850f004509f2aec5f4529.svg";
export { ForwardRef as ReactComponent };